<template>
  <app-section class="v2-sitemap" theme="nude">
    <div class="row">
      <div class="col col-md-6 col-lg-4">
        <h2>{{ t("Sitemap") }}</h2>
        <router-link to="/" class="btn btn-outline-dark mb-3 d-block">
          {{ t("Home") }}
        </router-link>
        <router-link to="/user-profile" class="btn btn-outline-dark mb-3 d-block">
          {{ t("Member Area") }}
        </router-link>
        <a href="/agb" class="btn btn-outline-dark mb-3 d-block">{{ t("2257 Notice / Legal") }}</a>
        <router-link to="/contact-us" class="btn btn-outline-dark mb-3 d-block">
          {{ t("Contact Us") }}
        </router-link>
      </div>
    </div>
  </app-section>
</template>

<script setup lang="ts">
import AppSection from "@/components/v2/section/index.vue";
import { useI18n } from "vue-i18n";

defineOptions({
  name: "sitemap-v2",
});

const { t } = useI18n();
</script>
